module.exports = __webpack_public_path__ + "static/media/june_2025_4.f39c3bf6.webp";